<div class="min-h-screen flex items-center justify-center bg-[var(--bg-dark)] text-white relative overflow-hidden p-4">

  <div class="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#506ef7]/20 rounded-full blur-[100px] pointer-events-none"></div>
  <div class="absolute bottom-[-10%] right-[-10%] w-[30%] h-[30%] bg-indigo-500/10 rounded-full blur-[80px] pointer-events-none"></div>

  <div class="w-full max-w-md p-8 bg-[var(--bg-panel)] border border-[#ffffff10] rounded-2xl shadow-2xl relative z-10 animate-fade-in backdrop-blur-xl">

    <div class="flex flex-col items-center mb-6">
      <div class="w-12 h-12 rounded-xl bg-[#506ef7]/20 flex items-center justify-center mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-[#506ef7]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      </div>
      <h1 class="text-xl font-bold text-white text-center">Set a new password</h1>
      <p class="text-sm text-[var(--text-muted)] text-center mt-1">You must change your password before you can continue.</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">

      @if (errorMessage()) {
        <div role="alert" class="bg-red-500/10 border border-red-500/50 text-red-400 px-4 py-3 rounded-xl text-sm flex items-start gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{{ errorMessage() }}</span>
        </div>
      }

      @if (successMessage()) {
        <div role="status" class="bg-green-500/10 border border-green-500/50 text-green-400 px-4 py-3 rounded-xl text-sm flex items-center gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{{ successMessage() }}</span>
        </div>
      }

      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-medium text-[var(--text-muted)] ml-1">Current password</label>
        <input formControlName="current_password" type="password" autocomplete="current-password"
          class="w-full px-4 py-3 bg-[#ffffff05] border border-[#ffffff10] rounded-xl text-white placeholder-[#ffffff40] focus:outline-none focus:border-[#506ef7] focus:ring-1 focus:ring-[#506ef7] transition-all"
          placeholder="Enter your current password"
          [class.border-red-500]="form.get('current_password')?.invalid && form.get('current_password')?.touched">
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-medium text-[var(--text-muted)] ml-1">New password</label>
        <input formControlName="new_password" type="password" autocomplete="new-password"
          class="w-full px-4 py-3 bg-[#ffffff05] border border-[#ffffff10] rounded-xl text-white placeholder-[#ffffff40] focus:outline-none focus:border-[#506ef7] focus:ring-1 focus:ring-[#506ef7] transition-all"
          placeholder="At least 6 characters"
          [class.border-red-500]="form.get('new_password')?.invalid && form.get('new_password')?.touched">
        @if (form.get('new_password')?.errors?.['minlength'] && form.get('new_password')?.touched) {
          <span class="text-xs text-red-400">Minimum 6 characters</span>
        }
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-medium text-[var(--text-muted)] ml-1">Confirm new password</label>
        <input formControlName="confirm_password" type="password" autocomplete="new-password"
          class="w-full px-4 py-3 bg-[#ffffff05] border border-[#ffffff10] rounded-xl text-white placeholder-[#ffffff40] focus:outline-none focus:border-[#506ef7] focus:ring-1 focus:ring-[#506ef7] transition-all"
          placeholder="Repeat new password"
          [class.border-red-500]="form.get('confirm_password')?.invalid && form.get('confirm_password')?.touched">
      </div>

      <button type="submit" [disabled]="isLoading()"
        class="w-full py-3 px-4 mt-2 bg-[#506ef7] hover:bg-[#4057db] text-white font-medium rounded-xl shadow-[0_4px_14px_0_rgba(80,110,247,0.39)] transition-all flex justify-center items-center h-12 disabled:opacity-70 disabled:cursor-not-allowed">

        @if (isLoading()) {
          <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
          <span class="ml-2">Updating…</span>
        } @else {
          Update password
        }
      </button>
    </form>

    <p class="text-xs text-[var(--text-muted)] text-center mt-6">
      Logged in as <span class="text-white font-medium">{{ currentUser?.email }}</span>
    </p>
  </div>
</div>
